import { useTranslation } from '../../../utils/useTranslation';
import { DataTestId } from '../../layout/DataTestIdWrapper';
import { Typography } from '../../typography/Typography';
import { AdvertisingPromoTextProps } from './types';

export const AdvertisingPromoText: React.FC<AdvertisingPromoTextProps> = ({ text, ...other }) => {
    const t = useTranslation();

    return (
        <Typography
            py={0.5}
            variant="caption"
            color="var(--color-invert)"
            dataTestId={DataTestId.ADVERTISING_PROMO_TEXT}
            {...other}
        >
            {text || t('Выбирайте товары для продвижения и зарабатывайте на показах')}
        </Typography>
    );
};
